<template>
    <div class="posfinder-screen__result" :class="{'is-open': openResult, 'is-hidden': initial}">
        <div class="posfinder-screen__tabs">
            <button class="h4 posfinder-screen__tab" @click.prevent="setResultOpen(true)">
                <span v-if="!initial">{{ resultCount }}</span>
                In deiner Nähe
            </button>
        </div>

        <div class="posfinder-screen__result-hide" @click.prevent="setResultOpen(false)"></div>

        <div class="posfinder-screen__result-content-wrapper">
            <div class="posfinder-screen__result-content">

                <template v-if="sortedResults.length === 0">
                    <template v-if="initial">
                        <p class="h4 posfinder-screen__headline" style="font-size: 28px;">
                            Noch keine Ergebnisse vorhanden
                        </p>
                    </template>
                    <template v-else>
                        <p class="h4 posfinder-screen__headline" style="font-size: 28px;">
                            Keine Ergebnisse gefunden
                        </p>
                    </template>
                </template>
                <Location v-else
                          v-for="(location, i) in sortedResults" :key="i"
                          :location="location"
                          :focus="location.focus"
                          @selectLocation="setResultOpen(false)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Location from "./partials/Location";
import Spinner from "./partials/Spinner";

import {mapState} from 'vuex'

export default {
    name: "ResultList",
    components: {Spinner, Location},
    props: {
        initial: Boolean
    },
    computed: {
        ...mapState({
            openResult: 'resultOpen',
        }),
        sortedResults(){
            return this.$store.state.results.sort((a, b) => {
                if (a.type !== b.type){
                    return a.type === 'retail'? -1 : 1;
                }
                return a.distance - b.distance;
            });
        },
        resultCount() {
            return this.sortedResults.length;
        }
    },
    methods: {
        setResultOpen(open) {
            this.$store.commit('setFormOpenState', false);
            this.$store.commit('setResultOpenState', open);
        }
    }
}
</script>
